import { type ReactNode, useState } from 'react'
import {AuthContext} from '../services/useAuth'
// Auth provider to wrap around the top level compoents allowing us to pass state
// through the components.
// To use: import useAuth from 'services/useAuth' and call; const auth = useAuth()
// auth.isAuthed() to get the current state
//
const AuthProvider = ({children}: {children: ReactNode}): JSX.Element => {
    const [isAuthed, setIsAuthed] = useState(false)
    
    const tokenFound = (): boolean => {
        const token = localStorage.getItem("token")
        if (!token || token === undefined || null) {
            setIsAuthed(false)
            return isAuthed
        } else {
            setIsAuthed(true)
            return isAuthed
        }
    }

    return (
        <AuthContext.Provider value={{isAuthed: tokenFound}} >
            {children}
        </AuthContext.Provider>
    )
}

export default AuthProvider